class OrderSource {
    constructor(API) {
        this.API = API;
    }

    async getPaymentLink(orderId)
    {
        return (await this.API.get('/index.php?route=api/order/pay', {
            params: {order_id: orderId}
        })).url
    }

    async history(params) {
        return await this.API.get('/index.php?route=api/order/historyv3', { params })
    }
    async totals(data) {
        return await this.API.get('/index.php?route=api/order/totals', {
            params: data
        })
    }

    async getById(data) {
        return await this.API.get('/index.php?route=api/order/info', {
            params: data
        })
    }

    async add(data) {
        return await this.API.post('/index.php?route=api/order/add',  data)
    }

    async reOrder(order_id) {
        return await this.API.post('/index.php?route=api/order/reorder',  {
            order_id: order_id
        })
    }

    async date_receiving_list() {
        return await this.API.get('/index.php?route=api/order/date_receiving')
    }

}

export default OrderSource
